// extracted by mini-css-extract-plugin
export default {"footer":"LkSwkiNlQMj6pxPmpBln","field":"OMV0AbYpQI6I6mjDkdva","cancel":"QRUl1a6dD0hQ5VNxOghY"};